<style>
.echarts {
  width: 100%;
  height: 100%;
}
.active_table {
  width: 100%;
  height: 100%;
}
.ch {
  width: 90vw;
  height: 90vh;
  margin: 0 auto;
}
</style>

<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <DatePicker
          type="daterange"
          placement="bottom-end"
          placeholder="选择日期"
          style="width: 200px; margin-left: 10px"
          @on-change="dateSelect($event)"
        ></DatePicker>
        <i-button type="default" @click="searchFunc" style="margin-left: 1em"
          >搜索</i-button
        >
      </div>
    </toolbar>
    <div class="ch">
      <div><h1>站点告警数</h1></div>
      <div>
        <v-chart autoresize :options="orgOptions" style="height: 60vh" />
      </div>
      <p></p>
    </div>
  </div>
</template>
 
<script>
import toolbar from "../toolBar.vue"; // 操作栏组件

export default {
  data() {
    return {
      orgOptions: {},
      // 查询
      search: {
        startDate: null,
        endDate: null,
      },
    };
  },
  components: {
    toolbar,
  },
  created: function () {
    this.getData();
  },
  methods: {
    getData() {
      var that = this;
      // 获取数据
      this.$api.BigData.getChart1({ content: this.search }, [
        "uuid",
        "company",
      ]).then((res) => {
        if (res.code == 0) {
          // 获取成功
          let warnData = res.data; //数据
          let dateList = []; // 标题
          let dataList = []; // 数据值
          warnData.map((res) => {
            dateList.push(res.date);
            dataList.push(res.count);
            //console.log(res.date);
          });

          this.orgOptions = {
            color: ["#3398DB"],
            tooltip: {
              trigger: "axis",
              formatter: function (params) {
                return (
                  params[0].name +
                  "<br/>合计告警时长:" +
                  that.formatSeconds(params[0].value)
                );
              },
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
              },
            },
            toolbox: {
              show: true,
              feature: {
                saveAsImage: {},
              },
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                name: "站点名称",
                boundaryGap: true,
                axisLabel: {
                  //底部文字倾斜
                  interval: 0,
                  rotate: 25,
                },
                data: dateList,
              },
            ],
            yAxis: [
              {
                type: "value",
              },
            ],
            series: [
              {
                name: "站点告警数",
                type: "bar",
                barWidth: "60%",
                data: dataList,
              },
            ],
          };
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
        }
      });
    },
    // 选择时间
    dateSelect(date) {
      this.search.startDate = new Date(date[0]).setHours("0");
      this.search.endDate = new Date(date[1]).setHours("24");
      //console.log(this.search);
    },
    // 搜索
    searchFunc() {
      this.getData();
    },
    formatSeconds(value) {
      var theTime0 = parseInt(value); // 需要转换的时间分
      var theTime1 = 0; // 小时
      var theTime2 = 0; // 天
      if (theTime0 > 60) {
        theTime1 = parseInt(theTime0 / 60);
        theTime0 = parseInt(theTime0 % 60);
        if (theTime1 > 24) {
          //大于24小时
          theTime2 = parseInt(theTime1 / 24);
          theTime1 = parseInt(theTime1 % 24);
        }
      }
      var result = "";
      if (theTime0 > 0) {
        result = "" + parseInt(theTime0) + "分" + result;
      }
      if (theTime1 > 0) {
        result = "" + parseInt(theTime1) + "小时" + result;
      }
      if (theTime2 > 0) {
        result = "" + parseInt(theTime2) + "天" + result;
      }
      return result;
    },
  },
};
</script>